
/* ================================
   GET ACTIVE SUPPORT FAQS
   Used in Help Page
================================ */

import { ApiList, ApiResponse } from "../../../types/api.types";
import axiosClient from "../../../utils/axios";
import { SupportFaq } from "../types/faq.types";

export const getActiveSupportFaqs = async () => {
  try {
    const response = await axiosClient.post<
      ApiResponse<ApiList<SupportFaq[]>>
    >("/faqs/active");

    return response.data;
  } catch (err) {
    console.warn("Error fetching support FAQs:", err);
    throw err;
  }
};